import { render, staticRenderFns } from "./changelog-active.vue?vue&type=template&id=3e136c79"
import script from "./changelog-active.vue?vue&type=script&lang=js"
export * from "./changelog-active.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports